import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIconDisabled.svg'
import _imports_1 from '@/assets/filterIcon.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 overflow-y-hidden" }
const _hoisted_2 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Activities", -1)
const _hoisted_4 = { class: "cardbody" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_6 = { class: "flex flex-row-reverse items-center" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "my-3 text-xs" }, " Risk management is the process of identifying, assessing and controlling financial, legal, strategic and security risks to an organization’s capital and earnings. These threats, or risks, could stem from a wide variety of sources, including financial uncertainty, legal liabilities, strategic management errors, accidents and natural disasters.To reduce risk, an organization needs to apply resources to minimize, monitor and control the impact of negative events while maximizing positive events. A consistent, systemic and integrated approach to risk management can help determine how best to identify, manage and mitigate significant risks. ", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", null, "Activity", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5 cursor-pointer"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "popup-business" }
const _hoisted_17 = { class: "popupbodycontainer" }
const _hoisted_18 = { class: "formcontainer flex flex-col" }
const _hoisted_19 = { class: "upperspacing w-full" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-xs" }, "Activity Name", -1)
const _hoisted_21 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_22 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_23 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_24 = {
  key: 2,
  class: "invalid-feedback text-xs"
}
const _hoisted_25 = { class: "row flex flex-row upperspacing w-full gap-3" }
const _hoisted_26 = { class: "w-1/2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-xs" }, "Department", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "No departments Found", -1)
const _hoisted_29 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_30 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_31 = { class: "w-1/2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-xs" }, "Criticality", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  hidden: ""
}, "Please select one", -1)
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_36 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_37 = { class: "upperspacing w-full" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-xs" }, "Description", -1)
const _hoisted_39 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_40 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_41 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_42 = {
  key: 0,
  class: "buttonposition flex justify-center items-center mb-4 mx-0 mt-4"
}
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 1,
  class: "buttonposition flex justify-center items-center mb-4 mx-0 mt-4"
}
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex items-center", _ctx.activitiesArray.length == 0?'btndisabled pointer-events-none':'filterButton h-8']),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              (_ctx.activitiesArray.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_openBlock(), _createElementBlock("img", _hoisted_8)),
              _createTextVNode(" Filters ")
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btnprimary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPopUp()))
            }, "Add")
          ])
        ])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", null, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.activitiesArray,
        headersData: _ctx.headers,
        tableProps: _ctx.tableProps,
        openPopup: false,
        navigate: true,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "tableProps", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showAddPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.showAddPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCancelButtonAddPopUp()))
              }, _hoisted_15)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _hoisted_20,
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': (_ctx.v$.activitiesObj.name.$error || _ctx.checkActivityName)}]),
                            placeholder: "Activity Name",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activitiesObj.name) = $event)),
                            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.activitiesObj.name.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.activitiesObj.name,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.activitiesObj.name.$error || _ctx.checkActivityName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (_ctx.v$.activitiesObj.name.required.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Required"))
                                  : (_ctx.v$.activitiesObj.name.required && _ctx.v$.activitiesObj.name.restrictCharacters.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Charcter Limit is exceeded"))
                                    : (_ctx.checkActivityName)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Activity Name already exists."))
                                      : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createVNode(_component_multiselect, {
                              modelValue: _ctx.activitiesObj.departments,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activitiesObj.departments) = $event)),
                              options: _ctx.teamsOptions,
                              showNoOptions: false,
                              onSearchChange: _ctx.asyncdepartmentDisplayFind,
                              multiple: false,
                              label: "label",
                              "track-by": "value",
                              searchable: true,
                              "close-on-select": true,
                              "show-labels": false,
                              "hide-selected": true,
                              placeholder: "Department",
                              "open-direction": "bottom",
                              class: _normalizeClass(["custom-multiselect userSelect", {
                                                    'is-invalidmultiselect': _ctx.v$.activitiesObj.departments.$error,
                                                    'has-options': _ctx.teamsOptions && _ctx.teamsOptions.length > 0,
                                                    'no-options': !_ctx.teamsOptions.length,
                                                }])
                            }, {
                              noResult: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options", "onSearchChange", "class"]),
                            (_ctx.v$.activitiesObj.departments.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  (_ctx.v$.activitiesObj.departments.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _withDirectives(_createElementVNode("select", {
                              class: _normalizeClass(["", {
                                                    'is-invalid': _ctx.v$.activitiesObj.criticality.$error,'inputboxstylingForSelectAtPopup': _ctx.activitiesObj.criticality === '','stylingForInputboxstylingForSelectAtPopup': _ctx.activitiesObj.criticality !== ''
                                                }]),
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activitiesObj.criticality) = $event))
                            }, [
                              _hoisted_33,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criticalityoptions, (option) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  class: "optionColors",
                                  key: option.id,
                                  value: option.id
                                }, _toDisplayString(option.value), 9, _hoisted_34))
                              }), 128))
                            ], 2), [
                              [_vModelSelect, _ctx.activitiesObj.criticality]
                            ]),
                            (_ctx.v$.activitiesObj.criticality.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  (_ctx.v$.activitiesObj.criticality.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _withDirectives(_createElementVNode("textarea", {
                            class: _normalizeClass(["inputboxstyling", {
                                                    'is-invalid': _ctx.v$.activitiesObj.description.$error
                                                }]),
                            placeholder: "Description",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activitiesObj.description) = $event)),
                            onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.activitiesObj.description.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.activitiesObj.description,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.activitiesObj.description.$error )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                (_ctx.v$.activitiesObj.description.required.$invalid )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, "Required"))
                                  : (_ctx.v$.activitiesObj.description.required && _ctx.v$.activitiesObj.description.restrictCharacters1.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_ctx.editPopup == false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["mr-2", (JSON.stringify(_ctx.dummyactivitiesObj) == JSON.stringify(_ctx.activitiesObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                              disabled: _ctx.clickOnButton,
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onCancelbtn()))
                            }, "Reset", 10, _hoisted_43),
                            _createElementVNode("button", {
                              class: _normalizeClass(["", (JSON.stringify(_ctx.dummyactivitiesObj) == JSON.stringify(_ctx.activitiesObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                              disabled: _ctx.clickOnButton,
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onClickSaveBtn(_ctx.activitiesObj)))
                            }, "Save", 10, _hoisted_44)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["mr-2", (JSON.stringify(_ctx.dummyactivitiesObj) == JSON.stringify(_ctx.activitiesObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                              disabled: _ctx.clickOnButton,
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onCancelbtn()))
                            }, "Cancel", 10, _hoisted_46),
                            _createElementVNode("button", {
                              class: _normalizeClass(["", (JSON.stringify(_ctx.dummyactivitiesObj) == JSON.stringify(_ctx.activitiesObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                              disabled: _ctx.clickOnButton,
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onClickUpdateBtn(_ctx.activitiesObj)))
                            }, "Update", 10, _hoisted_47)
                          ]))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}